import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const SoundProofIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "SoundProofIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M7.47642 15.7622C7.63703 15.7622 7.79761 15.7009 7.92017 15.5784C9.79406 13.7045 9.79406 10.6554 7.92017 8.78149C7.67507 8.53639 7.27776 8.53639 7.03266 8.78149C6.7876 9.02655 6.7876 9.4239 7.03266 9.66896C8.41722 11.0535 8.41722 13.3063 7.03266 14.6909C6.63617 15.0874 6.92238 15.7622 7.47642 15.7622Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M5.633 13.8011C5.79361 13.8011 5.95419 13.7399 6.07671 13.6173C6.8693 12.8247 6.8693 11.5352 6.07671 10.7426C5.83165 10.4975 5.4343 10.4975 5.18924 10.7426C4.94414 10.9877 4.94414 11.385 5.18924 11.6301C5.49242 11.9333 5.49242 12.4266 5.18924 12.7298C4.79263 13.1265 5.07908 13.8011 5.633 13.8011Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M9.04607 16.8743C8.64946 17.2709 8.9359 17.9456 9.48982 17.9456C9.65043 17.9456 9.81101 17.8843 9.93357 17.7617C13.0184 14.6769 13.0189 9.68347 9.93357 6.59818C9.68847 6.35308 9.29116 6.35308 9.0461 6.59818C8.801 6.84324 8.801 7.24059 9.0461 7.48565C11.6345 10.0741 11.6345 14.2858 9.04607 16.8743Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M20.1581 20.6519H19.9228V3.08055C19.9228 2.73399 19.6418 2.453 19.2952 2.453H16.3144C16.1128 2.453 15.9236 2.5498 15.8056 2.7132L15.1486 3.62314C14.5971 4.3871 14.5971 5.41369 15.1486 6.17769C15.383 6.50221 15.383 6.93835 15.1486 7.26287C14.5971 8.02687 14.5971 9.05346 15.1486 9.81742C15.383 10.142 15.383 10.5781 15.1486 10.9026C14.5971 11.6666 14.5971 12.6932 15.1486 13.4572C15.383 13.7817 15.383 14.2179 15.1486 14.5424C14.5971 15.3063 14.5971 16.3329 15.1486 17.0969C15.383 17.4215 15.383 17.8576 15.1486 18.1821C14.6173 18.9182 14.5981 19.8978 15.0906 20.6517H3.84191C3.49535 20.6517 3.21436 20.9327 3.21436 21.2793C3.21436 21.6258 3.49534 21.9068 3.84191 21.9068H20.1581C20.5047 21.9068 20.7857 21.6258 20.7857 21.2793C20.7857 20.9327 20.5047 20.6519 20.1581 20.6519ZM16.1662 16.3623C15.9319 16.0378 15.9319 15.6017 16.1662 15.2772C16.7178 14.5132 16.7178 13.4866 16.1662 12.7226C15.9319 12.3981 15.9319 11.962 16.1662 11.6374C16.7178 10.8734 16.7178 9.84684 16.1662 9.08284C15.9319 8.75832 15.9319 8.32218 16.1662 7.99766C16.7178 7.23366 16.7178 6.20707 16.1662 5.44311C15.9319 5.11855 15.9319 4.68245 16.1662 4.35793L16.6353 3.70811H18.6677V20.6333L16.6335 20.6493L16.1662 20.0021C15.9319 19.6776 15.9319 19.2414 16.1662 18.9169C16.7178 18.153 16.7178 17.1263 16.1662 16.3623Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default SoundProofIcon;
